import React from "react";
import { IPetsyHighestLevelPopupProps } from "./PetsyHighestLevelPopup.types";
import {
  Modal,
  Image,
} from "react-bootstrap";
import "./PetsyHighestLevelPopup.scss";
import _ from "lodash";


export default function PetsyHighestLevelPopup(props: IPetsyHighestLevelPopupProps) {
  const optionRef = React.useRef<any>();

  function OnClickCloseModal() {
    props.onClose();
  }

  if (props.show) {
    return (
      <div className="petsy-hightest-level">
        <div className="body">
          <div className="close-button" onClick={OnClickCloseModal}></div>
          <div className="content">
            <div className="left-content"> <Image className="" src={`/images/face-with-party-horn-and-party-hat.png`} /></div>
            <div className="right-content">
              Woohoo! You have selected the highest level of cover for your pet!
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (<></>);
  }

}
